import { render, staticRenderFns } from "./CoursesView.vue?vue&type=template&id=d56f9f62&scoped=true"
import script from "./CoursesView.vue?vue&type=script&lang=js"
export * from "./CoursesView.vue?vue&type=script&lang=js"
import style0 from "./CoursesView.vue?vue&type=style&index=0&id=d56f9f62&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d56f9f62",
  null
  
)

export default component.exports